export const enum Messages {
  AgreementHasInvalidNoticePeriod = 'AgreementHasInvalidNoticePeriod',
  SomethingWentWrong = 'SomethingWentWrong',
  SuccessfullyCreatedEmploymentHistoryRecord = 'SuccessfullyCreatedEmploymentHistoryRecord',
  CheckingOnlyForCoordinatorsTooltip = 'CheckingOnlyForCoordinatorsTooltip',
  SuccessfullyUpdatedEmploymentHistoryRecord = 'SuccessfullyUpdatedEmploymentHistoryRecord',
  SuccessfullySetBonus = 'SuccessfullySetBonus',
  WorkerFilePendingVerification = 'WorkerFilePendingVerification',
  WorkerFileVerificationApproveSuccess = 'WorkerFileVerificationApproveSuccess',
  WorkerFileVerificationRejectSuccess = 'WorkerFileVerificationRejectSuccess',
  SuccessfullySettledTimesheet = 'SuccessfullySettledTimesheet',
  SuccessfullySettledMultipleTimesheets = 'SuccessfullySettledMultipleTimesheets',
  SuccessfullyApprovedTimesheet = 'SuccessfullyApprovedTimesheet',
  SuccessfullyUnapprovedTimesheet = 'SuccessfullyUnapprovedTimesheet',
  SuccessfullyUpdatedWorkerProfileSettings = 'SuccessfullyUpdatedWorkerProfileSettings',
  SuccessfullyVoidedWorkerAgreement = 'SuccessfullyVoidedWorkerAgreement',
  SuccessfullyUndidWorkerAgreementVoiding = 'SuccessfullyUndidWorkerAgreementVoiding',
  WorkerAlreadyExists = 'WorkerAlreadyExists',
  SuccessfullyAssignedWorkerToEmployerObject = 'SuccessfullyAssignedWorkerToEmployerObject',
  EmployeeWillNotFillTimesheetIndependently = 'EmployeeWillNotFillTimesheetIndependently',
  EmployerObjectHasNoMpk = 'EmployerObjectHasNoMpk',
  ThereIsNoEmployerObjectForThisEmployer = 'ThereIsNoEmployerObjectForThisEmployer',
  ConfirmActionOnOverlappingAgreementTitle = 'ConfirmActionOnOverlappingAgreementTitle',
  ConfirmActionOnOverlappingAgreementMessage = 'ConfirmActionOnOverlappingAgreementMessage',
  SuccessfullySentExtensionConsents = 'SuccessfullySentExtensionConsents',
  SuccessfullyGeneratedWorkerAgreement = 'SuccessfullyGeneratedWorkerAgreement',
  ConfirmCancellingAgreementTitle = 'ConfirmCancellingAgreementTitle',
  ConfirmCancellingAgreementMessage = 'ConfirmCancellingAgreementMessage',
  ConfirmDeletingAgreementTitle = 'ConfirmDeletingAgreementTitle',
  SuccessfullyDeletedAgreement = 'SuccessfullyDeletedAgreement',
  SuccessfullyDeletedTimesheet = 'SuccessfullyDeletedTimesheet',
  SuccesfullyCreatedWorkerFamilyMember = 'SuccesfullyCreatedWorkerFamilyMember',
  SuccesfullyUpdatedWorkerFamilyMember = 'SuccesfullyUpdatedWorkerFamilyMember',
  SuccessfullyCreatedTimesheet = 'SuccessfullyCreatedTimesheet',
  SuccessfullyUpdatedTimesheet = 'SuccessfullyUpdatedTimesheet',
  SuccessfullyInsuredWorkerFamilyMember = 'SuccessfullyInsuredWorkerFamilyMember',
  SuccessfullyAddedWorkerFamilyMemberFile = 'SuccessfullyAddedWorkerFamilyMemberFile',
  ConfirmEducationHistoryRecordRemovalTitle = 'ConfirmEducationHistoryRecordRemovalTitle',
  ConfirmEducationHistoryRecordRemovalMessage = 'ConfirmEducationHistoryRecordRemovalMessage',
  SuccessfullyCreatedEducationHistoryRecord = 'SuccessfullyCreatedEducationHistoryRecord',
  SuccessfullyUpdatedEducationHistoryRecord = 'SuccessfullyUpdatedEducationHistoryRecord',
  SuccessfullyDeletedEducationHistoryRecord = 'SuccessfullyDeletedEducationHistoryRecord',
  SuccessfullyCreatedWageAllowanceRecord = 'SuccessfullyCreatedWageAllowanceRecord',
  SuccessfullyUpdatedWageAllowanceRecord = 'SuccessfullyUpdatedWageAllowanceRecord',
  SuccessfullyAddedEducationHistoryFile = 'SuccessfullyAddedEducationHistoryFile',
  ConfirmFamilyMemberRemovalTitle = 'ConfirmFamilyMemberRemovalTitle',
  ConfirmFamilyMemberRemovalMessage = 'ConfirmFamilyMemberRemovalMessage',
  SuccessfullyDeletedWorkerFamilyMember = 'SuccessfullyDeletedWorkerFamilyMember',
  SuccessfullyUpdatedWorkerEducationDegree = 'SuccessfullyUpdatedWorkerEducationDegree',
  SuccessfullyCreatedEmploymentAgreement = 'SuccessfullyCreatedEmploymentAgreement',
  SuccessfullyUpdatedEmploymentAgreement = 'SuccessfullyUpdatedEmploymentAgreement',
  ConfirmWageAllowanceRemovalTitle = 'ConfirmWageAllowanceRemovalTitle',
  ConfirmWageAllowanceRemovalMessage = 'ConfirmWageAllowanceRemovalMessage',
  SuccessfullyDeletedWageAllowance = 'SuccessfullyDeletedWageAllowance',
  ChooseOrganizationalUnit = 'ChooseOrganizationalUnit',
  EmptyOrganizationalUnitTree = 'EmptyOrganizationalUnitTree',
  ConfirmWageAllowanceUpdateTitle = 'ConfirmWageAllowanceUpdateTitle',
  ConfirmWageAllowanceUpdateMessage = 'ConfirmWageAllowanceUpdateMessage',
  Exceeded540DaysMessage = 'AF-ExceededTheLimitOf540DaysOfEmployment',
  ExceededMaxWageMessage = 'AF-ExceededMaxWageValue',
  NotExceededMinWageMessage = 'AF-NotExceededMinWageValue',
  ConclusionDateIsAfterEmploymentDateFrom = 'AF-ConclusionDateIsAfterEmploymentDateFrom',
  QuestionnairePreviousStepIsInvalid = 'QuestionnairePreviousStepIsInvalid',
  SuccessfullyCreatedAbsence = 'SuccessfullyCreatedAbsence',
  SuccessfullyUpdatedAbsence = 'SuccessfullyUpdatedAbsence',
  SuccessfullySavedAbsenceFiles = 'SuccessfullySavedAbsenceFiles',
  SuccessfullySentToApprovalAbsence = 'SuccessfullySentToApprovalAbsence',
  ConfirmDeletingAbsenceMessage = 'ConfirmDeletingAbsenceMessage',
  ConfirmDelegationHoursMessage = 'ConfirmDelegationHoursMessage',
  ConfirmDelegationHoursTitle = 'ConfirmDelegationHoursTitle',
  ConfirmDelegationHoursCancel = 'ConfirmDelegationHoursCancel',
  ConfirmDelegationHoursApprove = 'ConfirmDelegationHoursApprove',
  ConfirmConfirmingAbsenceMessage = 'ConfirmConfirmingAbsenceMessage',
  ConfirmSendingToApprovalAbsenceMessage = 'ConfirmSendingToApprovalAbsenceMessage',
  SuccessfullyDeletedAbsence = 'SuccessfullyDeletedAbsence',
  SuccessfullyBackToDraftAbsence = 'SuccessfullyBackToDraftAbsence',
  ConfirmBackToDraftAbsenceMessage = 'ConfirmBackToDraftAbsenceMessage',
  SuccessfullyCanceledAbsence = 'SuccessfullyCanceledAbsence',
  ConfirmCancellingAbsenceMessage = 'ConfirmCancellingAbsenceMessage',
  SuccesfullyAcceptedAbsence = 'SuccesfullyAcceptedAbsence',
  SuccesfullyRejectedAbsence = 'SuccesfullyRejectedAbsence',
  ConfirmAcceptingAbsenceMessage = 'ConfirmAcceptingAbsenceMessage',
  ConfirmRejectingAbsenceMessage = 'ConfirmRejectingAbsenceMessage',
  ConfirmRemoveDelegationInvoiceItemMessage = 'ConfirmRemoveDelegationInvoiceItemMessage',
  SuccessfullyConfirmedAbsence = 'SuccessfullyConfirmedAbsence',
  SuccessfullySendAbsencesRefreshRequest = 'SuccessfullySendAbsencesRefreshRequest',
  ChosenAgreementIsNotActive = 'ChosenAgreementIsNotActive',
  SuccessfullyGeneratedDocument = 'SuccessfullyGeneratedDocument',
  RemoveSupervisorTitle = 'RemoveSupervisorTitle',
  RemoveSupervisorMessage = 'RemoveSupervisorMessage',
  SuccessfullySendByPostMultipleDeclarations = 'SuccessfullySendByPostMultipleDeclarations',
  SuccessfullySharedMultipleDeclarations = 'SuccessfullySharedMultipleDeclarations',
  SuccessfullyStartedMultipleAgreementGenerationProcess = 'SuccessfullyStartedMultipleAgreementGenerationProcess',
  SuccessfullySentMultipleAgreeemntsToApproval = 'SuccessfullySentMultipleAgreeemntsToApproval',
  SuccessfullyStartedMultipleAgreementExtensionGenerationProcess = 'SuccessfullyStartedMultipleAgreementGenerationProcess',
  SuccessfullyCreatedDelegationRecord = 'SuccessfullyCreatedDelegationRecord',
  SuccessfullyUpdatedDelegationRecord = 'SuccessfullyUpdatedDelegationRecord',
  SuccessfullySentToApprovalDelegtion = 'SuccessfullySentToApprovalDelegtion',
  ConfirmDeletingDelegationMessage = 'ConfirmDeletingDelegationMessage',
  SuccessfullyAcceptDelegtion = 'SuccessfullyAcceptDelegtion',
  ConfirmAcceptingDelegationMessage = 'ConfirmAcceptingDelegationMessage',
  ConfirmRejectedDelegationMessage = 'ConfirmRejectedDelegationMessage',
  SuccessfullyRejectDelegtion = 'SuccessfullyRejectDelegtion',
  ConfirmRejectionDelegationMessage = 'ConfirmRejectionDelegationMessage',
  SuccessfullyDeletedDelegation = 'SuccessfullyDeletedDelegation',
  StudentAlert = 'StudentAlert',
  CannotBeStudentAndRetiredAtSameTime = 'CannotBeStudentAndRetiredAtSameTime',
  SuccessfullyDeletedDelegationInvoice = 'SuccessfullyDeletedDelegationInvoice',
  ConfirmDeletingDelegationInvoiceMessage = 'ConfirmDeletingDelegationInvoiceMessage',
  SuccessfullyDeletedDelegationMileage = 'SuccessfullyDeletedDelegationMileage',
  ConfirmDeletingDelegationMileageMessage = 'ConfirmDeletingDelegationMileageMessage',
  SuccessfullyCreatedDelegationInvoiceRecord = 'SuccessfullyCreatedDelegationInvoiceRecord',
  SuccessfullyUpdatedDelegationInvoiceRecord = 'SuccessfullyUpdatedDelegationInvoiceRecord',
  SuccessfullyCreatedDelegationMileageRecord = 'SuccessfullyCreatedDelegationInvoiceRecord',
  SuccessfullyUpdatedDelegationMileageRecord = 'SuccessfullyUpdatedDelegationInvoiceRecord',
  SuccessfullyCreatedDelegationSubsistenceAllowanceRecord = 'SuccessfullyCreatedDelegationSubsistenceAllowanceRecord',
  SuccessfullyUpdatedDelegationSubsistenceAllowanceRecord = 'SuccessfullyUpdatedDelegationSubsistenceAllowanceRecord',
  SuccessfullyDeletedDelegationSubsistenceAllowance = 'SuccessfullyDeletedDelegationSubsistenceAllowance',
  ConfirmDeletingDelegationSubsistenceAllowanceMessage = 'ConfirmDeletingDelegationSubsistenceAllowanceMessage',
  SuccessfullyCreatedDelegationLumpSumRecord = 'SuccessfullyCreatedDelegationLumpSumRecord',
  SuccessfullyUpdatedDelegationLumpSumRecord = 'SuccessfullyUpdatedDelegationLumpSumRecord',
  SuccessfullyDeletedDelegationLumpSum = 'SuccessfullyDeletedDelegationLumpSum',
  ConfirmDeletingDelegationLumpSumMessage = 'ConfirmDeletingDelegationLumpSumMessage',
  SuccesfullyUpdatedDelegationDates = 'SuccesfullyUpdatedDelegationDates',
  DelegationDatesChangedWarning = 'DelegationDatesChangedWarning',
  SuccesfullyAcceptedDelegationCostsMessage = 'SuccesfullyAcceptedDelegationCostsMessage',
  SuccessfullySendDelegationSettlementToPayment = 'SuccessfullySendDelegationSettlementToPayment',
  SuccessfullySendDelegationSettlementToCorrection = 'SuccessfullySendDelegationSettlementToCorrection',
  ChangedToDelegationSettlementEditStatus = 'ChangedToDelegationSettlementEditStatus',
  ConfirmDelegationSettlementCorrection = 'ConfirmDelegationSettlementCorrection',
  ConfirmAcceptingDelegationCostsMessage = 'ConfirmAcceptingDelegationCostsMessage',
  SuccessfullySendAgreementToGeneration = 'SuccessfullySendAgreementToGeneration',
  SuccessfullySendAgreementToVerification = 'SuccessfullySendAgreementToVerification',
  ConfirmSettleAllTimehseets = 'ConfirmSettleAllTimehseets',
  ConfirmSendDelegationCostsCorrectionMessage = 'ConfirmSendDelegationCostsCorrection',
  SuccesfullySendDelegationCostCorrectionMessage = 'SuccesfullySendDelegationCostCorrectionMessage',
  DelegationLumpSumDaysIsGreaterThanDelegationPeriod = 'DelegationLumpSumDaysIsGreaterThanDelegationPeriod',
  SuccesfullyApprovedLegalization = 'SuccesfullyApprovedLegalization',
  SuccesfullyRejectedLegalization = 'SuccesfullyRejectedLegalization',
  SuccesfullyChangedLegalizationStatus = 'SuccesfullyChangedLegalizationStatus',
  StartedReportGeneration = 'Reports.GenerationStarted',
  StartedEmploymentConditionsConfirmationsGeneration = 'StartedEmploymentConditionsConfirmationsGeneration',
  SuccessfullyDeletedReport = 'Reports.SuccessfullyDeleted',
  SuccesfullySentContact = 'SuccesfullySentContact',
  NoAgreementsToLogWorkTime = 'NoAgreementsToLogWorkTime',
  QrCodeExpired = 'QrCodeExpired',
  QrCodeInvalid = 'QrCodeInvalid',
  NoAgreementToLogWork = 'NoAgreementToLogWork',
  Exceeded24HoursWorkLog = 'Exceeded24HoursWorkLog',
  TwoEventsOverlap = 'TwoEventsOverlap',
  TimesheetIsSettled = 'TimesheetIsSettled',
  NewVersionIsAvailable = 'NewVersionIsAvailable',
  SuccessfullyDeregistratedWorkerFamilyMemberInsurance = 'SuccessfullyDeregistratedWorkerFamilyMemberInsurance',
  BeforeFirstDayLastMonthWarning = 'BeforeFirstDayLastMonthWarning',
  SuccessfullyCreatedOrder = 'Order.SuccessfullyCreatedOrder',
  RestoreOrderItemMessage = 'Order.List.RestoreOrderItemMessage',
  RestoreOrderItemConfirmButton = 'Order.List.RestoreOrderItem',
  ArchiveOrderItemMessage = 'Order.List.ArchiveOrderItemMessage',
  ArchiveOrderItemConfirmButton = 'Order.List.ArchiveOrderItem',
  OrderDeclineButton = 'Order.DeclineButton',
  SuccessfullyRestoredOrder = 'Order.SuccessfullyRestoredOrder',
  SuccessfullyArchivedOrder = 'Order.SuccessfullyArchivedOrder',
  ArchiveOrderItemTitle = 'Order.List.ArchiveOrderItemTitle',
  RestoreOrderItemTitle = 'Order.List.RestoreOrderItemTitle',
  CleanWorkerRealizationDateTitle = 'Order.StartRealizationList.CleanWorkerRealizationDateTitle',
  CleanWorkerRealizationDateMessage = 'Order.StartRealizationList.CleanWorkerRealizationDateMessage',
  CleanWorkerRealizationDateConfirmButton = 'Order.StartRealizationList.CleanWorkerRealizationConfirmButton',
  SuccessfullyCleanWorkerRealizationDate = 'Order.SuccessfullyCleanWorkerRealizationDate',
  SuccessfullyEditWorkerRealizationDate = 'Order.SuccessfullyEditWorkerRealizationDate',
  InvalidWorkerRealizationDate = 'Order.InvalidWorkerRealizationDate',
  InvalidWorkerOrderItemsToEdit = 'Order.InvalidWorkerOrderItemsToEdit',
  MassSuccessfullyEditWorkerRealizationDate = 'Order.MassSuccessfullyEditWorkerRealizationDate',
  StartDateIsNotValidToEdit = 'Order.StartDateIsNotValidToEdit',
  SuccessfullyEditedOrderItem = 'Order.SuccessfullyEditedOrderItem',
  ConfirmSubmitForLegalizationTitle = 'Legalization.ConfirmSubmitForLegalizationTitle',
  ConfirmSubmitForLegalization = 'Legalization.ConfirmSubmitForLegalization',
  ConfirmSubmitForMultipleLegalization = 'Legalization.ConfirmSubmitForMultipleLegalization',
  MultipleLegalizationSubmitted = 'Legalization.MultipleLegalizationSubmitted',
  SuccessfullySetTemporaryWorkEmployer = 'SuccessfullySetTemporaryWorkEmployer',
  AbsenceSubstitutionPeriodOverlap = 'AbsenceSubstitutionPeriodOverlap',
  ConfirmSettlingDelegationTitle = 'ConfirmSettlingDelegation.Title',
  ConfirmSettlingDelegationMessage = 'ConfirmSettlingDelegation.Message',
  SuccessfullySettlingDelegationMessage = 'ConfirmSettlingDelegation.SuccessfullyMessage',
}
